/**
 * The words of a sign-in refused over another person's unsent work (spec 15.4, the
 * shared-device gate in auth/gantiPengguna): the sentence under the form names the person
 * and the count and says what to do, the button offers the discard, the confirmation names
 * it again. A person the device cannot name is "pengguna lain"; several are listed.
 */
import { format, uiStrings as ui } from '@satu/shared'
import type { PemilikTertunda } from '../../auth/gantiPengguna'

export interface TeksPerubahanLain {
  jumlah: number
  kalimat: string
  /** "Buang 3 perubahan itu" */
  tombol: string
  /** The confirmation's title. */
  judul: string
}

const teks = ui.masuk.perubahanLain

/** "Maria K.", "Maria K. dan Yosef W.", "Maria K., Yosef W. dan pengguna lain". */
function daftarNama(nama: readonly string[]): string {
  if (nama.length <= 1) return nama[0] ?? teks.penggunaLain
  return format(teks.gabung, { depan: nama.slice(0, -1).join(', '), akhir: nama.at(-1) ?? '' })
}

export function teksPerubahanLain(pemilik: readonly PemilikTertunda[]): TeksPerubahanLain {
  const jumlah = pemilik.reduce((n, p) => n + p.jumlah, 0)
  const dikenal = [...new Set(pemilik.flatMap((p) => (p.nama === null ? [] : [p.nama])))]
  const adaTanpaNama = pemilik.some((p) => p.nama === null)
  const nama = daftarNama(adaTanpaNama ? [...dikenal, teks.penggunaLain] : dikenal)
  const templat =
    dikenal.length === 0
      ? teks.kalimatTanpaNama
      : dikenal.length === 1 && !adaTanpaNama
        ? teks.kalimat
        : teks.kalimatBanyak
  return {
    jumlah,
    kalimat: format(templat, { jumlah, nama }),
    tombol: format(teks.buang, { jumlah }),
    judul: format(ui.dialog.buangPerubahanLain.judul, { jumlah, nama }),
  }
}
